// extracted by mini-css-extract-plugin
module.exports =  {"rating-container":"_v9Ef0L","ratingContainer":"_v9Ef0L","rating":"ywbicbw","score":"C4cV8dm","star":"FJzTgYZ","count":"Ye1D5RQ"};